var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41276 14.9517L8.29485 10.8313C8.42327 10.2587 8.71252 9.73467 9.1286 9.32086L17.1882 1.33378C18.0055 0.501205 19.1152 0.0200553 20.2815 -0.00747349C21.1612 -0.0200777 22.0095 0.319228 22.6378 0.935027C24.0107 2.55717 23.8334 4.97958 22.239 6.38461L14.1794 14.4442C13.7656 14.8603 13.2416 15.1495 12.669 15.2779L8.5486 16.16H8.31901C8.01779 16.1716 7.73008 16.0345 7.54921 15.7934C7.36835 15.5522 7.31735 15.2376 7.41276 14.9517ZM10.4094 10.6138C10.2401 10.7778 10.1225 10.9879 10.0711 11.2179L9.47901 14.0334L12.2944 13.4292C12.5245 13.3778 12.7345 13.2602 12.8986 13.0909L20.9582 5.03128C21.8411 4.32443 22.0163 3.05019 21.3569 2.13128C21.0682 1.85542 20.6806 1.70736 20.2815 1.72044C19.5935 1.74807 18.9433 2.04283 18.469 2.54211L10.4094 10.6138Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0578 9.70753C21.56 9.71404 21.158 10.116 21.1515 10.6138V17.4892C21.1677 18.461 20.793 19.3987 20.1114 20.0916C19.4298 20.7845 18.4985 21.1747 17.5265 21.1746H6.0111C4.00209 21.1352 2.39228 19.4986 2.3861 17.4892V6.02211C2.41908 4.01034 4.05948 2.39684 6.07152 2.39711H12.9469C13.4474 2.39711 13.8532 1.99137 13.8532 1.49086C13.8532 0.990352 13.4474 0.58461 12.9469 0.58461H6.0111C2.99812 0.584428 0.546293 3.00931 0.513184 6.02211V17.4892C0.513184 20.5256 2.97469 22.9871 6.0111 22.9871H17.4782C20.5099 22.9804 22.964 20.5209 22.964 17.4892V10.6138C22.9575 10.116 22.5556 9.71404 22.0578 9.70753Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteIcon);
export default __webpack_public_path__ + "static/media/write_icon.d2ff98cdfd8125bc462b30f252ab2ec1.svg";
export { ForwardRef as ReactComponent };